// extracted by mini-css-extract-plugin
export default {"container":"PMaxAssetGroups_container__fKL1N"};